import { useState } from "react";
import {
    Box,
    Typography,
    Switch
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { DiseñoDataGrid } from "../FuncionesGenerales/DataGrid";
import { TituloColor } from "../../Layouts/CustomStyles";
import { useFinanzasTodosINMOB } from "../../Hook/Inmobiliaria/Finanzas";

export const FinanzasINMOB = () => {
    const {
        finanzasTotales,
        loadingFinanzasTotales,
         finanzasTotalesMontoNeto,
        loadingFinanzasTotalesMontoNeto,
    } = useFinanzasTodosINMOB();
    const [mostrarMontoNeto, setMostrarMontoNeto] = useState(false);
    const mesesNombre = [
    "Enero", "Febrero", "Marzo", "Abril",
    "Mayo", "Junio", "Julio", "Agosto",
    "Septiembre", "Octubre", "Noviembre", "Diciembre"
];

    // 🔥 transformar data
    const rows = finanzasTotales?.map((item, index) => ({
        id: index,
        periodo:  `${mesesNombre[item.mes - 1]} ${item.anio}`,
        total_ingresos: item.total_ingresos,
        total_egresos: item.total_egresos,
        balance: item.balance,
    })) || [];

    // 🔥 columnas
    const columns = [
        {
            field: "periodo",
            headerName: "Periodo",
            flex: 1,
        },
        {
            field: "total_ingresos",
            headerName: "Ingresos",
            flex: 1,
            renderCell: (params) =>
                `$${params.value.toLocaleString("es-CL")}`,
        },
        {
            field: "total_egresos",
            headerName: "Egresos",
            flex: 1,
            renderCell: (params) =>
                `$${params.value.toLocaleString("es-CL")}`,
        },
        {
            field: "balance",
            headerName: "Balance",
            flex: 1,
            renderCell: (params) => {
                const value = params.value;
                return (
                    <span
                        style={{
                            color: value >= 0 ? "green" : "red",
                            fontWeight: "bold",
                        }}
                    >
                        ${value.toLocaleString("es-CL")}
                    </span>
                );
            },
        },
    ];

     const rowsDOs = finanzasTotalesMontoNeto?.map((item, index) => ({
        id: index,
        periodo:  `${mesesNombre[item.mes - 1]} ${item.anio}`,
        total_ingresos: item.total_ingresos,
        total_egresos: item.total_egresos,
        balance: item.balance,
    })) || [];

    // 🔥 columnas
    const columnsDos = [
        {
            field: "periodo",
            headerName: "Periodo",
            flex: 1,
        },
        {
            field: "total_ingresos",
            headerName: "Ingresos",
            flex: 1,
            renderCell: (params) =>
                `$${params.value.toLocaleString("es-CL")}`,
        },
        {
            field: "total_egresos",
            headerName: "Egresos",
            flex: 1,
            renderCell: (params) =>
                `$${params.value.toLocaleString("es-CL")}`,
        },
        {
            field: "balance",
            headerName: "Balance",
            flex: 1,
            renderCell: (params) => {
                const value = params.value;
                return (
                    <span
                        style={{
                            color: value >= 0 ? "green" : "red",
                            fontWeight: "bold",
                        }}
                    >
                        ${value.toLocaleString("es-CL")}
                    </span>
                );
            },
        },
    ];

    return (
        <Box mt={6} p={1}>
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mb: 2
                }}
            >
                <Typography variant="h5" sx={TituloColor}>
                    Finanzas Inmobiliaria Fisiomed
                </Typography>
            </Box>

            <Box
    sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        mb: 2,
        mt: 2,
    }}
>
    <Typography
        sx={{
            fontFamily: "Poppins",
            fontWeight: 600,
            color: "#2a8d74"
        }}
    >
        {mostrarMontoNeto ? "Vista Monto Neto" : "Vista Monto total"}
    </Typography>

    <Box
        sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
        }}
    >
        <Typography
            sx={{
                fontFamily: "Poppins",
                color: !mostrarMontoNeto ? "#2a8d74" : "#888",
                fontWeight: 600
            }}
        >
            Total
        </Typography>

        <Switch
            checked={mostrarMontoNeto}
            onChange={(e) =>
                setMostrarMontoNeto(e.target.checked)
            }
            color="success"
        />

        <Typography
            sx={{
                fontFamily: "Poppins",
                color: mostrarMontoNeto ? "#2a8d74" : "#888",
                fontWeight: 600
            }}
        >
            Neto
        </Typography>
    </Box>
</Box>

           <Box sx={{ height: 500, width: "100%" }}>
    {!mostrarMontoNeto ? (
        <DataGrid
            rows={rows}
            columns={columns}
            loading={loadingFinanzasTotales}
            pageSizeOptions={[5, 10, 20]}
            initialState={{
                pagination: {
                    paginationModel: { pageSize: 10 }
                }
            }}
            slots={{ noRowsOverlay: DiseñoDataGrid }}
            getRowId={(row) => row.id}
            sx={{
                fontFamily: "Poppins, sans-serif",
                "& .MuiDataGrid-columnHeaders": {
                    color: "#113e21ff",
                    fontWeight: 600,
                },
            }}
        />
    ) : (
        <DataGrid
            rows={rowsDOs}
            columns={columnsDos}
            loading={loadingFinanzasTotalesMontoNeto}
            pageSizeOptions={[5, 10, 20]}
            initialState={{
                pagination: {
                    paginationModel: { pageSize: 10 }
                }
            }}
            slots={{ noRowsOverlay: DiseñoDataGrid }}
            getRowId={(row) => row.id}
            sx={{
                fontFamily: "Poppins, sans-serif",
                "& .MuiDataGrid-columnHeaders": {
                    color: "#113e21ff",
                    fontWeight: 600,
                },
            }}
        />
    )}
</Box>
        </Box>
    );
};